import { useState, useEffect } from "react";
import { useAuth, API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import { Trash2, Loader2, MessageSquare, User } from "lucide-react";

const CommentsManager = () => {
  const { authAxios } = useAuth();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchComments();
  }, []);

  const fetchComments = async () => {
    try {
      const response = await axios.get(`${API}/comments`);
      setComments(response.data);
    } catch (e) {
      toast.error("Failed to fetch comments");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this comment?")) return;
    
    try {
      await authAxios.delete(`/comments/${id}`);
      toast.success("Comment deleted");
      fetchComments();
    } catch (e) {
      toast.error("Failed to delete comment");
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-6 h-6 text-purple-400 animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h2 className="font-orbitron text-xl text-white flex items-center gap-2">
          <MessageSquare className="w-5 h-5 text-purple-400" />
          Comments Moderation ({comments.length})
        </h2>
      </div>

      {/* Comments List */}
      <div className="space-y-3">
        {comments.map(comment => (
          <div key={comment.id} className="cyber-card p-4 border-l-2 border-purple-400/50">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-purple-400/10 flex items-center justify-center flex-shrink-0">
                <User className="w-5 h-5 text-purple-400" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-1">
                  <span className="font-orbitron text-sm text-purple-400">{comment.user_name}</span>
                  <span className="font-rajdhani text-xs text-gray-600">{formatDate(comment.created_at)}</span>
                </div>
                <p className="font-rajdhani text-sm text-gray-300">{comment.content}</p>
              </div>
              <button
                onClick={() => handleDelete(comment.id)}
                className="text-gray-500 hover:text-red-500 transition-colors p-2 flex-shrink-0"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
      </div>

      {comments.length === 0 && (
        <div className="text-center py-12 cyber-card">
          <MessageSquare className="w-12 h-12 text-gray-600 mx-auto mb-4" />
          <p className="font-rajdhani text-gray-500">No comments yet.</p>
        </div>
      )}
    </div>
  );
};

export default CommentsManager;
